export const data = [
        "Services List 1",
        "Services List 2",
        "Services List 3",
        "Services List 4"
    ]